<template>
  <form class="bank-deposit-page" :class="{ 'bank-deposit-page--dark': $vuetify.theme.dark }">
    <v-container fluid class="main-container responsive-height bank-deposit-container">
      <header class="bank-deposit-heading">
        <span><v-icon>mdi-bank-transfer-in</v-icon></span>
        <div><h1>Bank Deposit</h1><p>Transfer funds securely from your bank to your trading account.</p></div>
      </header>
      <v-row>
        <v-col xl="6" lg="7" md="7" sm="7" cols="12">
          <v-card class="deposit-form bank-deposit-form-card">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transfer Method</legend>
                  <v-text-field label="Bank Transfer" disabled placeholder="Bank Transfer" single-line solo hide-details
                    readonly class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Deposit to</legend>
                  <v-select v-model="selectedAccount" :items="formattedAccounts" item-text="display"
                    item-value="trading_account_no" solo append-icon="mdi-chevron-down" label="Select One"
                    class="custom-select" hide-details @change="handleAccountChange"></v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" :md="currencyAmount ? 6 : 12">
                <fieldset>
                  <legend>
                    Amount in (USD)
                    <small v-if="minTransactionUSD > 0" class="ms-2 text-muted">
                      (Min: ${{ minTransactionUSD }})
                    </small>
                  </legend>

                  <v-text-field :min="minTransactionUSD > 0 ? minTransactionUSD : 1" v-model="depositAmount" label="$"
                    type="number" single-line solo hide-details class="custom-select" :rules="amountRules"
                    :error="errors.amount" :error-messages="amountErrorMessages"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" v-if="currencyAmount" :md="currencyAmount ? 6 : 12">
                <fieldset>
                  <legend>{{ bankConversionLegend }}</legend>
                  <v-text-field v-model="currencyAmount" :label="bankConversionInputLabel" single-line solo hide-details readonly
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Bank Name</legend>
                  <v-select v-model="selectedBank" :items="filteredBanks" item-text="beneficiary_bank_name"
                    item-value="id" solo append-icon="mdi-chevron-down" label="Select One" class="custom-select"
                    hide-details @change="handleBankChange"></v-select>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Bank Account Number</legend>
                  <v-text-field v-model="bankAccountNumber" :value="selectedBankAccount" label="Bank Account Number"
                    single-line solo hide-details readonly class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Upi I'd</legend>
                  <v-text-field v-model="bankUpi" label="Bank Upi I'd"
                    single-line solo hide-details readonly class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Account name</legend>
                  <v-text-field v-model="beneficiaryName" label="Bank Account Name"
                    single-line solo hide-details readonly class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" v-if="bankIbanNum != 'N/A'" :md="ifscCode != 'N/A' ? 6 : 12">
                <fieldset>
                  <legend>Beneficiary IBAN</legend>
                  <v-text-field v-model="bankIbanNum" label="Beneficiary IBAN" single-line solo hide-details readonly
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" v-if="ifscCode != 'N/A'" :md="bankIbanNum != 'N/A' ? 6 : 12">
                <fieldset>
                  <legend>IFSC Code</legend>
                  <v-text-field v-model="ifscCode" label="IFSC Code" single-line solo hide-details readonly
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="6" v-if="currency.name !== 'USD'">
                <fieldset>
                  <legend>Amount in <span :style="{ color: currency.color }">({{ currency.name }})</span></legend>
                  <v-text-field readonly v-model="currencyAmount" :label="currency.symbol" type="number" single-line
                    solo hide-details class="custom-select text-muted"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transaction ID</legend>
                  <v-text-field v-model="transactionId" label="Transaction ID" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" sm="12" md="12" v-if="needSlip == 1">
                <div class="input-file">
                  <span>Upload Bank Slip</span>
                  <v-file-input v-model="bankSlip" label="Choose file" filled prepend-icon="mdi-file-image"
                    hide-details></v-file-input>
                </div>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-btn type="submit" @click.prevent="handleSubmit" tile elevation="0"
                  class="ma-0 text-capitalize btn-account d-block bank-deposit-button" :loading="loading"
                  :disabled="loading || !isFormValid">
                  Deposit
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col xl="4" lg="4" md="5" sm="5" cols="12">
          <v-card v-if="selectedAccountDetails" class="elevation-0 deposit-form-card bank-summary-card mt-2">
            <v-card-actions>
              <div class="trade-status">
                <div>
                  <v-icon>mdi-signal</v-icon>
                </div>
                <div class="trade-number">
                  <span>MT5 - {{ selectedAccountDetails.account_type_display }}</span>
                  <span>{{ selectedAccountDetails.trading_account_no }}</span>
                </div>
              </div>
            </v-card-actions>

            <v-card-actions>
              <div class="value-trades">
                <span>Balance</span>
                <span>{{ selectedAccountDetails.Balance }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="value-trades">
                <span>Currency</span>
                <span>{{ selectedAccountDetails.currency_name }}</span>
              </div>
            </v-card-actions>

            <v-card-actions>
              <v-sheet :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                <div>
                  <apexChart width="100%" height="95px" type="line" :options="options" :series="series" />
                </div>
              </v-sheet>
            </v-card-actions>

            <v-card-actions>
              <div class="currency-leverage">
                <span>Free Funds</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="currency-leverage">
                <span>Leverage</span>
                <span>{{ selectedAccountDetails.leverage }}:1</span>
              </div>
            </v-card-actions>

            <v-card-actions>
              <div class="balance-equity">
                <span>Free Margin</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="balance-equity">
                <span>Acc. Type</span>
                <span>{{ selectedAccountDetails.account_type_display }}</span>
              </div>
            </v-card-actions>
          </v-card>

          <v-card v-if="selectedAccountDetails?.is_trade_master == 1"
            class="elevation-0 deposit-form-card bank-summary-card mt-2 mb-5">
            <v-card-actions>
              <div class="value-trades">
                <p>Investment Rule</p>
              </div>
            </v-card-actions>

            <v-card-actions>
              <span class="rules-info">
                <p class="color-white">1.First Deposit:</p>
                <li>The first deposit must be $1,000 plus an annual fee of $110.</li>
                <li>Total First Deposit = $1,110</li>
              </span>
            </v-card-actions>

            <v-card-actions>
              <span class="rules-info mt-3">
                <p class="color-white">2.Subsequent Deposits:</p>
                <li>Any additional deposit must be a multiple of $500.</li>
                <li>Allowed amounts: $500, $1,000, $1,500, $2,000, etc.</li>
                <li>Not allowed: $600, $750, $1,250, etc.</li>
              </span>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { DEPOSITMETHODS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      payment_id: null,

      //  min deposit from payment_settings.min_transaction
      minTransactionUSD: 0,

      selectedAccount: null,
      selectedBank: null,
      bankAccountNumber: "",
      bankIbanNum: "",
      bankUpi: "",
      beneficiaryName: "",
      ifscCode: "",
      depositAmount: "",
      currencyAmount: "",
      transactionId: "",
      usd_to_inr: "",
      bankSlip: null,
      loading: false,

      //  error state for amount validation
      errors: {
        amount: false,
      },

      currency: {
        rate: 1,
        name: "USD",
        symbol: "$",
        color: "#ffc400",
      },

      options: {
        chart: { type: "line", toolbar: { show: false } },
        xaxis: { labels: { show: false }, axisTicks: { show: false }, axisBorder: { show: false } },
        yaxis: { labels: { show: false } },
        grid: { show: false },
        stroke: { width: 2 },
        dataLabels: { enabled: false },
        colors: ["#ffc400"],
      },
      series: [{ name: "Series 1", data: [45, 52, 38, 45, 19, 23, 2] }],
    };
  },

  computed: {
    ...mapState("deposit", ["methods", "accounts", "banks", "needSlip"]),

    //  form valid includes min_transaction validation
    isFormValid() {
      const amt = parseFloat(this.depositAmount);
      if (!Number.isFinite(amt) || amt <= 0) return false;
      if (this.minTransactionUSD && amt < this.minTransactionUSD) return false;
      return true;
    },

    amountRules() {
      return [
        (v) => !!v || "Amount is required",
        (v) => parseFloat(v) > 0 || "Amount must be greater than 0",
        (v) =>
          !this.minTransactionUSD ||
          parseFloat(v) >= this.minTransactionUSD ||
          `Minimum deposit is $${this.minTransactionUSD}`,
      ];
    },

    amountErrorMessages() {
      if (!this.errors.amount) return [];
      const amt = parseFloat(this.depositAmount);

      if (!this.depositAmount || !Number.isFinite(amt) || amt <= 0) return ["Amount is required"];
      if (this.minTransactionUSD && amt < this.minTransactionUSD) return [`Minimum deposit is $${this.minTransactionUSD}`];
      return ["Invalid amount"];
    },

    filteredBanks() {
      if (!this.depositAmount) return [];
      const amount = parseFloat(this.depositAmount);

      return this.banks.filter((bank) => {
        const min = parseFloat(bank.minimum_deposit);
        const max = parseFloat(bank.maximum_deposit);
        return amount >= min && amount <= max;
      });
    },

    formattedAccounts() {
      return this.accounts.map((account) => ({
        display: `${account.trading_account_no} (${account.account_type_display}) ${account.Balance} ${account.currency_name}`,
        trading_account_no: account.trading_account_no,
        ...account,
      }));
    },

    selectedAccountDetails() {
      return this.accounts.find((acc) => acc.trading_account_no === this.selectedAccount);
    },

    selectedBankDetails() {
      return this.banks.find((bank) => String(bank.id) === String(this.selectedBank));
    },

    bankConversionCurrency() {
      if (this.bankHasCountryAccess(this.selectedBankDetails, 132)) {
        return "MYR";
      }

      return "INR";
    },

    bankConversionLegend() {
      return `USD To ${this.bankConversionCurrency}`;
    },

    bankConversionInputLabel() {
      return `usd to ${this.bankConversionCurrency.toLowerCase()}`;
    },

    selectedBankAccount() {
      if (this.selectedBank) {
        const bank = this.selectedBankDetails;
        return bank ? bank.beneficiary_account : "";
      }
      return "";
    },
  },

  watch: {
    depositAmount(newAmount) {
      // keep your existing INR conversion logic intact
      const bank = this.selectedBankDetails;
      if (bank) {
        this.currencyAmount = (newAmount * bank.usd_to_inr).toFixed(2);
      } else {
        this.currencyAmount = "";
      }

      //  live validation
      const amt = parseFloat(newAmount);
      this.errors.amount =
        !newAmount ||
        !Number.isFinite(amt) ||
        amt <= 0 ||
        (this.minTransactionUSD ? amt < this.minTransactionUSD : false);
    },

    methods: {
      handler() {
        this.pickMinTransactionFromMethods();
      },
      immediate: true,
    },

    payment_id() {
      this.pickMinTransactionFromMethods();
    },
  },

  methods: {
    ...mapActions("deposit", [
      DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS,
      DEPOSITMETHODS__ACTIONS.DEPOSITMETHODS,
      DEPOSITMETHODS__ACTIONS.BROKERSBANK,
      DEPOSITMETHODS__ACTIONS.CREATEBANKDEPOSIT,
      DEPOSITMETHODS__ACTIONS.NEEDSLIP,
    ]),

    //  pick payment_settings.min_transaction using URL payment_id
    pickMinTransactionFromMethods() {
      try {
        if (!this.payment_id || !Array.isArray(this.methods)) return;

        const method =
          this.methods.find(
            (m) =>
              String(m.id) === String(this.payment_id) ||
              String(m.payment_id) === String(this.payment_id) ||
              String(m.payment_settings_id) === String(this.payment_id)
          ) || null;

        const min =
          method?.payment_settings?.min_transaction ??
          method?.min_transaction ??
          method?.minTransaction ??
          0;

        this.minTransactionUSD = Number(min) || 0;
      } catch (e) {
        this.minTransactionUSD = 0;
      }
    },

    handleMethodChange() {
      this.selectedBank = null;
      this.bankAccountNumber = "";
      this.bankSlip = null;
    },

    bankHasCountryAccess(bank, countryId) {
      if (!bank?.country_access) return false;

      return String(bank.country_access)
        .split(",")
        .map((id) => id.trim())
        .includes(String(countryId));
    },

    handleAccountChange() {
      const account_details = this.accounts.find((acc) => acc.trading_account_no === this.selectedAccount);

      this.depositAmount = "";
      this.currencyAmount = "";

      if (account_details) {
        this.currency.rate = account_details.currency_rate;
        this.currency.name = account_details.currency_name;
        this.currency.symbol = account_details.currency_symbol;
        this.currency.color = account_details.symbol_color;
      }
    },

    handleBankChange() {
      const bank = this.selectedBankDetails;

      if (bank) {
        this.usd_to_inr = bank.usd_to_inr;
        this.bankAccountNumber = bank.beneficiary_account;
        this.bankIbanNum = bank.beneficiary_IBAN || 'N/A';
        this.ifscCode = bank.ifsc_code || 'N/A';
        this.bankUpi = bank.upi || 'N/A';
        this.beneficiaryName = bank.beneficiary_name || 'N/A';

        if (this.depositAmount) {
          this.currencyAmount = (this.depositAmount * bank.usd_to_inr).toFixed(2);
        }
      } else {
        this.usd_to_inr = "";
      }
    },

    async handleSubmit() {
      try {
        this.loading = true;

        const amount = parseFloat(this.depositAmount);

        //  min deposit validation (payment_settings.min_transaction)
        if (!Number.isFinite(amount) || amount <= 0) {
          this.loading = false;
          return toast.error("Please enter a valid deposit amount");
        }
        if (this.minTransactionUSD && amount < this.minTransactionUSD) {
          this.loading = false;
          return toast.error(`Minimum deposit is $${this.minTransactionUSD}`);
        }

        const formData = new FormData();
        formData.append("trading_account_no", this.selectedAccount);
        formData.append("amount", this.depositAmount);
        formData.append("transaction_id", this.transactionId);
        formData.append("payment_slip", this.bankSlip);
        formData.append("bank_id", this.selectedBank);
        formData.append("bank_account_no", this.bankAccountNumber);
        formData.append("payment_id", this.payment_id);

        await this[DEPOSITMETHODS__ACTIONS.CREATEBANKDEPOSIT](formData);
      } catch (error) {
        console.error("Deposit submission error:", error.message);
      } finally {
        this.loading = false;
        this.resetForm();
      }
    },

    resetForm() {
      this.selectedAccount = null;
      this.selectedBank = null;
      this.bankAccountNumber = "";
      this.depositAmount = "";
      this.transactionId = "";
      this.bankSlip = null;
      this.errors = { amount: false };
    },
  },

  async created() {
    this.payment_id = this.$route.query.payment_id;

    await this[DEPOSITMETHODS__ACTIONS.DEPOSITMETHODS]();
    await this[DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS]();
    await this[DEPOSITMETHODS__ACTIONS.BROKERSBANK]();
    await this[DEPOSITMETHODS__ACTIONS.NEEDSLIP]();

    // ensure minTransactionUSD set after methods loaded
    this.pickMinTransactionFromMethods();
  },
};
</script>

<style lang="scss" scoped>
.bank-deposit-page {
  --bank-page: #f7f8fa; --bank-panel: #fff; --bank-soft: #f4f5f7; --bank-field: #fff;
  --bank-border: #dfe2e6; --bank-text: #171a1f; --bank-muted: #626973; --bank-gold: #d99a00;
  box-sizing: border-box; height: calc(100vh - 64px); min-height: 100%; overflow-x: hidden; overflow-y: auto;
  color: var(--bank-text); background: var(--bank-page); overscroll-behavior-y: contain; -webkit-overflow-scrolling: touch;
}
.bank-deposit-page--dark {
  --bank-page: #030b13; --bank-panel: #07111b; --bank-soft: #0b1621; --bank-field: #08131e;
  --bank-border: #293026; --bank-text: #f4f5f7; --bank-muted: #aeb6c0; --bank-gold: #ffc400;
  background: radial-gradient(circle at 70% 14%, rgba(255, 196, 0, .05), transparent 34%), var(--bank-page);
}
.bank-deposit-container { box-sizing: border-box; max-width: none !important; min-height: 100%; padding: 16px 18px 24px !important; }
.bank-deposit-heading { min-height: 64px; display: flex; align-items: center; gap: 13px; margin-bottom: 8px; }
.bank-deposit-heading > span { width: 42px; height: 42px; display: inline-flex; align-items: center; justify-content: center; color: var(--bank-gold); border: 1px solid rgba(217, 154, 0, .42); border-radius: 9px; background: rgba(217, 154, 0, .09); }
.bank-deposit-heading .v-icon { color: inherit; }
.bank-deposit-heading h1 { margin: 0 0 3px; color: var(--bank-text); font-size: 23px; line-height: 1.2; }
.bank-deposit-heading p { margin: 0; color: var(--bank-muted); font-size: 13px; }
.bank-deposit-form-card, .bank-summary-card { color: var(--bank-text) !important; border: 1px solid var(--bank-border); border-radius: 10px !important; background: var(--bank-panel) !important; box-shadow: none !important; }
.bank-deposit-form-card { padding: 12px 14px; }
/* Preserve the original form sizing and structure; update colors only. */
.bank-deposit-page .deposit-form fieldset { border-color: var(--bank-border) !important; background: var(--bank-field) !important; }
.bank-deposit-page .deposit-form fieldset legend { color: var(--bank-text) !important; background: var(--bank-panel) !important; }
.bank-deposit-page::v-deep .deposit-form fieldset .custom-select .v-input__slot { border-color: transparent !important; background: var(--bank-field) !important; }
.bank-deposit-page::v-deep .deposit-form fieldset .custom-select input,
.bank-deposit-page::v-deep .deposit-form fieldset .custom-select .v-select__selection { color: var(--bank-text) !important; }
.bank-deposit-page::v-deep .deposit-form fieldset .custom-select .v-label,
.bank-deposit-page::v-deep .deposit-form fieldset .custom-select input::placeholder,
.bank-deposit-page::v-deep .deposit-form .input-file .v-label { color: var(--bank-muted) !important; opacity: .78; }
.bank-deposit-page::v-deep .deposit-form fieldset .custom-select .v-icon { color: var(--bank-gold) !important; }
.bank-deposit-page .deposit-form .input-file > span { color: var(--bank-text) !important; }
.bank-deposit-page::v-deep .deposit-form .input-file .v-input { color: var(--bank-gold) !important; background: var(--bank-field) !important; }
.bank-deposit-page::v-deep .deposit-form .input-file .v-input__slot { background: transparent !important; }
.bank-deposit-page::v-deep .deposit-form .input-file .v-icon,
.bank-deposit-page::v-deep .deposit-form .input-file .v-file-input__text { color: var(--bank-gold) !important; }
.bank-deposit-page legend small { color: var(--bank-gold) !important; }
.bank-deposit-button { width: 100%; height: 44px !important; color: #17130a !important; border-radius: 6px !important; background: linear-gradient(135deg, #ffd43b, #ffc400) !important; font-weight: 700; }
.bank-summary-card { overflow: hidden; }
.bank-summary-card > .v-card__actions { min-height: 58px; padding: 12px 16px; border-bottom: 1px solid var(--bank-border); }
.bank-summary-card > .v-card__actions:last-child { border-bottom: 0; }
.trade-status { display: flex; align-items: center; gap: 11px; }
.trade-status > div:first-child { width: 39px; height: 39px; display: inline-flex; align-items: center; justify-content: center; border-radius: 7px; background: rgba(217, 154, 0, .1); }
.trade-status .v-icon { color: var(--bank-gold) !important; }
.trade-number, .value-trades, .currency-leverage, .balance-equity { display: flex; flex-direction: column; gap: 3px; }
.trade-number span:first-child, .value-trades span:last-child, .currency-leverage span:last-child, .balance-equity span:last-child { color: var(--bank-text); font-weight: 600; }
.trade-number span:last-child, .value-trades span:first-child, .currency-leverage span:first-child, .balance-equity span:first-child { color: var(--bank-muted); font-size: 11px; }
.rules-info { max-width: 100%; color: var(--bank-muted); font-size: 12px; line-height: 1.6; overflow-wrap: anywhere; }
.rules-info p { margin-bottom: 5px; color: var(--bank-gold) !important; font-weight: 700; }
.text-muted { opacity: .7; }
@media (max-width: 760px) {
  .bank-deposit-page { height: calc(100vh - 56px); height: calc(100dvh - 56px); }
  .bank-deposit-container { padding: 12px 10px 20px !important; }
  .bank-deposit-container > .row { margin-right: -6px; margin-left: -6px; }
  .bank-deposit-container > .row > [class*="col-"] { width: 100%; max-width: 100%; flex: 0 0 100%; padding: 6px; }
  .bank-deposit-heading p { display: none; }
  .bank-deposit-heading h1 { font-size: 21px; }
  .bank-deposit-form-card { padding: 7px; }
  .bank-deposit-form-card > .row { margin-right: -6px; margin-left: -6px; }
  .bank-deposit-form-card > .row > [class*="col-"] { padding: 6px; }
  .bank-deposit-button { width: 100%; }
  .bank-summary-card { margin-top: 6px !important; }
}
@media (max-width: 380px) {
  .bank-deposit-heading > span { width: 38px; height: 38px; }
  .bank-deposit-heading h1 { font-size: 19px; }
}
</style>
